import { Stack, Text, Wrap, WrapItem } from "@chakra-ui/react";
import { references } from "../../constants/references";
import { HeadLine } from "../HeadLine";
import { ContentCard } from "./ContentCard";
import { Reveal } from "../Reveal";

export function References() {
  return (
    <Stack w={"100%"} bg={"#1D1D25"} id="testimonials" pt={"40px"} pb={"60px"}>
      <Reveal direction="up" amount={0.2}>
        <HeadLine
          as="h1"
          text={
            <Text color="white">
              <b>Kundenstimmen </b>
            </Text>
          }
        />
      </Reveal>
      <Wrap justify={"center"} mt={"50px"} spacing={"55px"}>
        {references.map((reference, i) => {
          return (
            <WrapItem key={i}>
              <Reveal direction="up" delay={i * 0.06}>
                <ContentCard
                  href={reference?.href}
                  linkTitle={reference?.linkTitle}
                  image={reference?.Image}
                  alt={reference?.alt}
                  title={reference?.title}
                  text={reference?.text}
                  audio={reference?.audio}
                  contentHeight={"145px"}
                />
              </Reveal>
            </WrapItem>
          );
        })}
      </Wrap>
    </Stack>
  );
}
